// @ts-nocheck
import { useDispatch, useSelector } from 'react-redux'

import { updateCartAction } from 'shared/store/ducks/cart'
import { withI18n } from 'shared/utils/withI18n'
import { IState, NowDataState } from 'types/redux'
import Select from 'views/components/molecules/Select'

const DEFAULT_MAXIMUM = 50

const DEFAULT_FACTOR = 3

const ProductListingSelect = ({
  product,
  i18n,
  isERx,
  disabledSelect,
  hasOverdraft,
  hasOverdraftMaxed,
  evaluatedProductType,
}) => {
  const nowData: NowDataState = useSelector((state: IState) => state.nowData)
  const dispatch = useDispatch()

  let highestOption =
    product.maxAmountInCart > 0
      ? product.maxAmountInCart * DEFAULT_FACTOR
      : DEFAULT_MAXIMUM

  if (product.maxOfferQuantity && highestOption > product.maxOfferQuantity) {
    highestOption = product.maxOfferQuantity
  }

  const options = []
  for (let i = 1; i <= highestOption; i += 1) {
    options.push({ value: i, text: String(i) })
  }
  if (product.quantity > highestOption) {
    options.push({ value: product.quantity, text: String(product.quantity) })
  }

  const id = `productListItemSelect__${
    isERx ? product.hashedToken : product.productId
  }`

  return (
    <Select
      selectedValue={product.quantity}
      options={options}
      id={id}
      name={id}
      label={i18n._('general.label.quantity')}
      floatingLabel
      disabled={isERx || hasOverdraftMaxed || disabledSelect}
      onChange={event =>
        dispatch(
          updateCartAction(
            event.target.value,
            product,
            evaluatedProductType,
            nowData
          )
        )
      }
      dataQa={`cart-entry-quantity-select`}
      hasOverdraft={hasOverdraft}
      hasOverdraftMaxed={hasOverdraftMaxed}
      className="o-ProductListing__select"
      volumePricing={product.volumeBasedPrices}
      basePrice={product.price}
    />
  )
}

export default withI18n()(ProductListingSelect)
